var esES = {
  locale: 'es_ES',
  direction: 'ltr',
  date: {
    defaultFormat: {
      week: 'WW/YYYY',
      date: 'DD/MM/YYYY',
      month: 'MM/YYYY',
      year: 'YYYY',
      time: 'HH:mm:ss',
      dateTime: 'DD/MM/YYYY HH:mm:ss'
    },
    startDay: 0,
    shortMonthList: ['Ene.', 'Febr.', 'Mzo.', 'Abr.', 'My.', 'Jun,', 'Jul.', 'Agt.', 'Sept.', 'Oct.', 'Nov.', 'Dic.'],
    monthList: ['Ene.', 'Febr.', 'Mzo.', 'Abr.', 'My.', 'Jun,', 'Jul.', 'Agt.', 'Sept.', 'Oct.', 'Nov.', 'Dic.'],
    shortDayList: ['Do.', 'Lu.', 'Ma.', 'Mi.', 'Ju.', 'Vi.', 'Sá.'],
    dayList: ['Do.', 'Lu.', 'Ma.', 'Mi.', 'Ju.', 'Vi.', 'Sá.'],
    shortestDayList: ['Do.', 'Lu.', 'Ma.', 'Mi.', 'Ju.', 'Vi.', 'Sá.']
  },
  'dynamic-date': {
    day: 'Día',
    week: 'Semana',
    month: 'Mes',
    quarter: 'Trimestre',
    year: 'Año',
    before: 'Antes de ${value}${unit}'
  },
  'auto-complete.empty': 'No hay datos',
  'select.selected-count': '${count} elementos seleccionados',
  'date-time-picker.date': 'Selecciona la fecha',
  'image-view.zoom-out': 'Alejar',
  'input.placeholder': 'Introduce',
  'empty.text': 'No hay datos',
  'date-picker.cancel': 'Cancelar',
  'date-picker.end': 'Fecha y hora de finalización',
  'cascader.empty': 'No hay datos',
  'upload.drop': 'Arrastra los archivos aquí o',
  'color.custom': 'Personalizar color',
  'cascader.titles': ['Nivel 1', 'Nivel 2', 'Nivel 3', 'Nivel 4', 'Nivel 5', 'Nivel 6', 'Nivel 7', 'Nivel 8'],
  'date-comparison.error-target': 'Selecciona la fecha y hora de finalización para la comparación',
  'transfer.empty': 'No hay datos',
  'select.search.placeholder': 'Introduce',
  'upload.click': 'Haz clic para cargar',
  'date-time-picker.placeholder': 'Introduce',
  'pager.jump': 'Redirigir',
  'tree-select.placeholder': 'Introduce',
  'dynamic-date.interval': 'Intervalo',
  'modal.cancel': 'Cancelar',
  'image-view.rotate': 'Girar',
  'tabs.more': 'Más',
  'popover.ok': 'Confirmar',
  'transfer.placeholder': 'Introduce',
  'date.month': 'Mes',
  'select.selected': 'Seleccionado',
  'popover.cancel': 'Cancelar',
  'image-view.prev': 'Anterior',
  'table.emptyText': 'No hay datos',
  'date-time-picker.ok': 'Confirmar',
  'table.filter.confirm': 'Confirmar',
  'tree-select.empty': 'No hay datos',
  'dynamic-date.fixed-date': 'Fecha fija',
  'date-comparison.compare': 'Comparar',
  'auto-complete.placeholder': 'Introduce',
  'time-picker.placeholder': 'Selecciona la hora',
  'date.month-first': true,
  'select.clear': 'Borrar',
  'date.year': '${year}',
  'date-comparison.yoy': 'Este periodo el año pasado',
  'image-view.zoom-to-origin': 'Origen',
  'schedule.title': 'Fecha/Hora',
  'schedule.clear': 'Borrar',
  'date-time-picker.end': 'Selecciona la fecha y hora de finalización',
  'dynamic-date.customize': 'Personalizar',
  'date-picker.apply': 'Aplicar',
  'schedule.selected': 'Fecha y hora seleccionada',
  'dynamic-date.dynamic-date': 'Fecha dinámica',
  'select.placeholder': 'Selecciona',
  'schedule.separator': ', ',
  'cascader.search': 'Introduce',
  'date-picker.invalid-range': 'El intervalo de fecha y hora seleccionado supera el rango seleccionable. Selecciona uno válido.',
  'dynamic-date.date-preview': 'Vista previa de fecha',
  'select.empty': 'No hay datos',
  'image-view.next': 'Siguiente',
  'date-time-picker.now': 'Ahora',
  'date-time-picker.time': 'Selecciona la hora',
  'tree.empty': 'No hay datos',
  'pager.total': '${total} registros en total',
  'image-view.zoom-in': 'Acercar',
  'date-picker.placeholder': 'Selecciona la fecha',
  'textarea.placeholder': 'Introduce',
  'date.week': 'Semana',
  'pager.size': '${count} registros/página',
  'modal.ok': 'Confirmar',
  'date-picker.start': 'Fecha y hora de inicio',
  'table.filter.reset': 'Restablecer',
  'image-view.zoom-to-fit': 'Ajustar',
  'pager.page.placeholder': 'Introduce',
  'select.select-all': 'Seleccionar todo',
  'list-viewer.empty': 'No hay datos',
  'date-comparison.compare-text': 'vs.',
  'transfer.source': 'Lista de origen',
  'date-time-picker.start': 'Selecciona la fecha y hora de inicio',
  'date-comparison.error-source': 'Selecciona la fecha y hora de inicio para la comparación',
  'upload.error.overflow-count': 'Número máximo de archivos superado',
  'date-comparison.placeholder': 'Fecha y hora de inicio-Fecha y hora de finalización',
  'time-range-picker.placeholder': 'Fecha y hora de inicio-Fecha y hora de finalización',
  'date-comparison.mom': 'En comparación con el periodo anterior',
  'transfer.target': 'Lista de destino'
};
export default esES;